import React from "react";
import {Card, Typography} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ServiceCard({ item }) {
    const navigate = useNavigate();

    return <Card
      sx={{cursor: 'pointer', transition: 'all 0.3s ease', backgroundColor: 'primary.soft', px:4, py:5, mb:2,
        '&:hover': {boxShadow: 3, transform: 'translateY(-2px)'},
      }}
      onClick={() => navigate(item.ref)}
    >
        <Typography variant="h4" sx={{ color: 'black', fontFamily:'Inter'}}>{item.button_title}</Typography>
        <Typography variant="body1" sx={{color: "black", fontSize:16, mb:3}}>{item.label}</Typography>

        {item.actions.map((action, index) => 
            <Typography key={index} sx={{ py:1, pl:3, fontSize:16, fontWeight:'bold', color:'grey'}}>{action}</Typography>
        )}
    </Card>
}